// Misc
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

// Styles
const styles = {
  root: {
    width: '100%',
    height: '100%',
  }
}

const Svg = ({ className, id, viewBox, classes }) => (
  <svg
    viewBox={viewBox}
    className={classNames(classes.root, className)}
  >
    <use xlinkHref={`#${id}`} />
  </svg>
)

Svg.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.any,
  id: PropTypes.string.isRequired,
  viewBox: PropTypes.string.isRequired,
}

export default withStyles(styles)(Svg)
